var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 24,
    viewBox: "0 0 12 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.72866 23.5696C9.48043 23.5705 9.23517 23.5157 9.01089 23.4093C8.78661 23.3029 8.58902 23.1476 8.43264 22.9549L0.407283 12.9855C0.162897 12.6882 0.0292969 12.3152 0.0292969 11.9304C0.0292969 11.5455 0.162897 11.1726 0.407283 10.8753L8.71511 0.905908C8.99714 0.566589 9.40241 0.353203 9.84177 0.312695C10.2811 0.272186 10.7186 0.407873 11.0579 0.689905C11.3972 0.971936 11.6106 1.37721 11.6511 1.81657C11.6916 2.25593 11.5559 2.69339 11.2739 3.03271L3.84672 11.9387L11.0247 20.8447C11.2279 21.0886 11.3569 21.3856 11.3966 21.7005C11.4363 22.0155 11.3849 22.3352 11.2486 22.6219C11.1122 22.9085 10.8966 23.1501 10.6273 23.3181C10.3579 23.4861 10.0461 23.5734 9.72866 23.5696Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.a83f7cd5.svg";
export { ForwardRef as ReactComponent };